module.exports = __webpack_public_path__ + "static/media/transfer_stock.192aed31.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/transfer_stock.svg
// module id = 192
// module chunks = 0